import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, Wand2 } from "lucide-react";
import { api, errMessage } from "../../lib/api";

const TOOLS = [
  ["shorter", "Shorter"],
  ["longer", "Longer"],
  ["professional", "More professional"],
  ["casual", "More casual"],
  ["funny", "More funny"],
  ["premium", "More premium"],
  ["sales", "More sales-focused"],
  ["remove_emojis", "Remove emojis"],
  ["add_emojis", "Add emojis"],
  ["regenerate", "Regenerate"],
  ["translate_nl", "Translate to Dutch"],
  ["translate_en", "Translate to English"],
  ["variation", "Another version"],
];

export default function CaptionEditor({ value, onChange, onUsage, testIdPrefix = "caption" }) {
  const [busy, setBusy] = useState("");

  const run = async (action) => {
    setBusy(action);
    try {
      const { data } = await api.post("/engine/caption", { text: value, action });
      if (data.caption) {
        onChange(data.caption);
        toast.success("Caption updated.");
      }
      onUsage?.();
    } catch (e) {
      toast.error(errMessage(e));
    } finally {
      setBusy("");
    }
  };

  return (
    <div data-testid={`${testIdPrefix}-editor`}>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={8}
        data-testid={`${testIdPrefix}-textarea`}
        className="w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-base leading-relaxed text-slate-900 outline-none transition-colors focus:border-[#F95738]"
      />
      <div className="mt-3 flex flex-wrap gap-2">
        {TOOLS.map(([action, label]) => (
          <button
            key={action}
            type="button"
            disabled={!!busy}
            onClick={() => run(action)}
            data-testid={`${testIdPrefix}-tool-${action.replace(/_/g, "-")}`}
            className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 transition-colors hover:border-slate-400 disabled:opacity-50"
          >
            {busy === action ? (
              <Loader2 className="h-3 w-3 animate-spin" aria-hidden="true" />
            ) : (
              <Wand2 className="h-3 w-3 text-[#F95738]" aria-hidden="true" />
            )}
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
